/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Gift_ContactInputs */

const en_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact us to find out how`)
};

const es_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contáctanos para saber cómo`)
};

const de_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktieren Sie uns, um herauszufinden, wie`)
};

const zh_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系我们了解如何操作`)
};

const ar_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل معنا لمعرفة الطريقة`)
};

const fr_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactez-nous pour savoir comment`)
};

const vi_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ chúng tôi để biết cách`)
};

const sw_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasiliana nasi ili kujua jinsi`)
};

const th_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดต่อเราเพื่อสอบถามวิธีการ`)
};

const bs_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktirajte nas da saznate kako`)
};

const ja_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入方法はお問い合わせください`)
};

const ko_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방법을 알아보려면 문의하세요`)
};

const pt_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fale conosco para saber como`)
};

const it_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contattaci per scoprire come`)
};

const sv_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakta oss för att ta reda på hur`)
};

const nl_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neem contact met ons op om erachter te komen hoe`)
};

const da_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt os for at finde ud af hvordan`)
};

const nb_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt oss for å finne ut hvordan`)
};

const fi_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ota yhteyttä selvittääksesi miten`)
};

const pl_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skontaktuj się z nami, aby dowiedzieć się, jak`)
};

const ru_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свяжитесь с нами, чтобы узнать, как`)
};

const tr_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasıl yapılacağını öğrenmek için bize ulaşın`)
};

const hi_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तरीका जानने के लिए हमसे संपर्क करें`)
};

const id_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi kami untuk mengetahui caranya`)
};

const ms_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi kami untuk mengetahui caranya`)
};

const cs_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktujte nás a zjistěte jak`)
};

const el_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επικοινωνήστε μαζί μας για να μάθετε πώς`)
};

const he_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צרו איתנו קשר כדי לברר איך`)
};

const af_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontak ons om uit te vind hoe`)
};

const hu_prices_gift_contact = /** @type {(inputs: Prices_Gift_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lépjen kapcsolatba velünk, hogy megtudja, hogyan`)
};

/**
* | output |
* | --- |
* | "Contact us to find out how" |
*
* @param {Prices_Gift_ContactInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_gift_contact = /** @type {((inputs?: Prices_Gift_ContactInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Gift_ContactInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_gift_contact(inputs)
	if (locale === "de") return de_prices_gift_contact(inputs)
	if (locale === "zh") return zh_prices_gift_contact(inputs)
	if (locale === "ar") return ar_prices_gift_contact(inputs)
	if (locale === "fr") return fr_prices_gift_contact(inputs)
	if (locale === "vi") return vi_prices_gift_contact(inputs)
	if (locale === "sw") return sw_prices_gift_contact(inputs)
	if (locale === "th") return th_prices_gift_contact(inputs)
	if (locale === "bs") return bs_prices_gift_contact(inputs)
	if (locale === "ja") return ja_prices_gift_contact(inputs)
	if (locale === "ko") return ko_prices_gift_contact(inputs)
	if (locale === "pt") return pt_prices_gift_contact(inputs)
	if (locale === "it") return it_prices_gift_contact(inputs)
	if (locale === "sv") return sv_prices_gift_contact(inputs)
	if (locale === "nl") return nl_prices_gift_contact(inputs)
	if (locale === "da") return da_prices_gift_contact(inputs)
	if (locale === "nb") return nb_prices_gift_contact(inputs)
	if (locale === "fi") return fi_prices_gift_contact(inputs)
	if (locale === "pl") return pl_prices_gift_contact(inputs)
	if (locale === "ru") return ru_prices_gift_contact(inputs)
	if (locale === "tr") return tr_prices_gift_contact(inputs)
	if (locale === "hi") return hi_prices_gift_contact(inputs)
	if (locale === "id") return id_prices_gift_contact(inputs)
	if (locale === "ms") return ms_prices_gift_contact(inputs)
	if (locale === "cs") return cs_prices_gift_contact(inputs)
	if (locale === "el") return el_prices_gift_contact(inputs)
	if (locale === "he") return he_prices_gift_contact(inputs)
	if (locale === "af") return af_prices_gift_contact(inputs)
	if (locale === "hu") return hu_prices_gift_contact(inputs)
	return en_prices_gift_contact(inputs)
});